import React, { useContext, useEffect, useState } from "react";
import "../../../Clients/ClientModals/FilterModal.css";
import { UnderContractPanelContext } from "../UnderContractPanelContext";
import closeSvg from "../../../../../assets/closeSvg";
import { AppContext } from "../../../../../AppContext";
import { logActivity } from "../../../../utils";

const AgentQuestionModal = () => {
  const {
    agentQuestionModal,
    setAgentQuestionModal,
    clientName,
    id,
    agentEmails,
    loanOfficerEmail,
    loanEngineerEmail,
    loanProcessorEmail,
  } = useContext(UnderContractPanelContext);

  const { userName, userType, userEmail, makeKey, userCompany } =
    useContext(AppContext);

  const agentNoteUrl = `/.netlify/functions/agentNoteUrl`;

  const visible = agentQuestionModal ? "" : "hidden";
  const [comment, setComment] = useState("");

  let agentEmailOne = "";
  let agentEmailTwo = "";
  if (agentEmails && agentEmails.includes(",")) {
    const agentEmailArray = agentEmails.split(",");
    agentEmailOne = agentEmailArray[0];
    agentEmailTwo = agentEmailArray[1];
  } else if (agentEmails) {
    agentEmailOne = agentEmails;
  } else {
    //Basically if agent email does not exist, we are assigning it a valid email address so that the LO can still click the buttons and send notifications to the processing team.
    agentEmailOne = userEmail;
  }

  return (
    <>
      <div className={`Modal-background filter ${visible}`}></div>
      <div
        className={`filter-modal-container ${visible}`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className={`filter-modal editNotes`}>
          <form
            className="modal-container"
            onSubmit={(e) => {
              e.preventDefault();
              if (comment.length > 0) {
                const confirmation = window.confirm("Click OK to send.");
                if (confirmation) {
                  fetch(agentNoteUrl, {
                    headers: {
                      "Content-Type": "application/json",
                      Accept: "application/json",
                    },
                  })
                    .then((response) => response.json())
                    .then((data) => {
                      fetch(data.url, {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Accept: "application/json",
                        },
                        body: JSON.stringify({
                          apiKey: makeKey,
                          id: id,
                          userType: userType,
                          comment: comment,
                          loanOfficerEmail: loanOfficerEmail,
                          loanEngineerEmail: loanEngineerEmail,
                          loanProcessorEmail: loanProcessorEmail,
                          agentEmailOne: agentEmailOne,
                          agentEmailTwo: agentEmailTwo,
                          userName: userName,
                          clientName: clientName,
                          email: "Question",
                          userEmail: userEmail,
                        }),
                      });
                    });
                  logActivity({
                    apiKey: makeKey,
                    userEmail: userEmail,
                    userType: userType,
                    action: "Sent Question",
                    tab: "Under Contract",
                    userCompany: userCompany,
                  });
                  setAgentQuestionModal(false);
                  e.target.reset();
                }
              } else {
                alert("Please add a note before sending.");
              }
            }}
          >
            <div className="spaceBetween">
              <div>
                <b>Send Question</b>
              </div>
              <div
                className="textAlignRight"
                onClick={(e) => {
                  setAgentQuestionModal(false);
                }}
              >
                {closeSvg}
              </div>
            </div>
            <div>
              Send a question to the Move team regarding the transaction.
            </div>
            <div className="tenPx"></div>
            <textarea
              className="fieldInput"
              maxLength={255}
              type="text"
              onChange={(e) => {
                setComment(e.target.value);
              }}
            ></textarea>
            <div className="tenPx"></div>
            <div className="fivePx"></div>
            <button className="button defaultColors" type="submit">
              Send
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default AgentQuestionModal;
